import React, {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {useAppContext} from "../../../context/AppContext";
import ConfiguredDoor from "./ConfiguredDoor";


const Scene = () => {
    const {watch, getValues} = useFormContext();

    const configuration = watch("configuration");
    const {state} = useAppContext();

    const {view,} =
        state;




    const floorImageHref = `assets/${view}_floor.jpg`;

    return (
        <div className="h-full w-full lg:max-w-full overflow-hidden bg-[#eeecea]">
            <svg
                className="bg-[#eeecea] w-full lg:max-w-full h-full"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                // viewBox={`0 0 ${svgViewportWidth} 2800`}
                viewBox="0 0 3840 2800"
                preserveAspectRatio="xMidYMid slice"
            >
                <g width="100%" height="100%" transform="translate(-200,2370)" opacity="0">
                    <rect width="12000" height="100%"/>
                </g>
                <g width="100%" height="100%" transform="translate(0,370)">
                    <image
                        // x="-2500"
                        x='0'
                        y="2128"
                        // width="9000"
                        width='100%'
                        height="100%"
                        xlinkHref={floorImageHref}
                        preserveAspectRatio="xMaxYMin"
                        mask="url(#ground_mask)"
                    ></image>
                    {view === "external" && (
                        <>
                            <image
                                x="545"
                                y="1200"
                                width="570"
                                height="1220"
                                xlinkHref="/assets/furniture/plant-pot_Left-sm-bg.png"
                                preserveAspectRatio="xMidYMin"
                            ></image>
                            <image
                                x="2920"
                                y="1200"
                                width="570"
                                height="1220"
                                xlinkHref="/assets/furniture/plant-pot_Right-sm-bg.png"
                                preserveAspectRatio="xMidYMin"
                            ></image>
                        </>
                    )}
                    {view === "internal" && (
                        <>
                            <image
                                x="2900" y="1200" width="1700" height="1500"
                                preserveAspectRatio="xMidYMin"
                                xlinkHref="/assets/furniture/Cabinet-1-sm.png"
                            ></image>
                        </>
                    )}
                </g>
                <ConfiguredDoor translate='translate(1365,370)'/>
                <defs>
                    <mask id="ground_mask">
                        <rect
                            // width="9000"
                            width='5000px'
                            height="100%"
                            fill="white"
                            // x="-2000"
                            x="0"
                            y="2156"
                        ></rect>
                        {['a', 'd'].includes(configuration) && (
                            <polygon
                                fill="white"
                                points="1165,2158 1195,2128 2865,2128 2895,2158"
                            ></polygon>
                        )}
                        {['b', 'e'].includes(configuration) && (
                            <polygon
                                fill="white"
                                points="1165,2158 1195,2128 2565,2128 2595,2158"
                            ></polygon>
                        )}
                        {['c', 'f'].includes(configuration) && (
                            <polygon
                                fill="white"
                                points="1485,2158 1515,2128 2865,2128 2895,2158"
                            ></polygon>
                        )}
                        {['none'].includes(configuration) && (
                            <polygon
                                fill="white"
                                points="1485,2158 1515,2128 2565,2128 2595,2158"
                            ></polygon>
                        )}
                    </mask>
                </defs>
            </svg>
        </div>
    );
};

export default Scene;


